import { SVGProps } from 'react';

/**
 * Lowercase "i" in a circle, stroked on `currentColor` so it picks up the
 * colour of the text it sits next to. Use for neutral, non-interactive notes
 * (disclaimers, hints) — the white-filled `InfoIcon` is for dark surfaces and
 * `HelpCircleIcon` reads as "help & support" rather than "information".
 */
export const InfoCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" />
    <path d="M12 8h.01" />
  </svg>
);
